import React from 'react';
import { ShieldCheckIcon, DownloadIcon, LockIcon, HeadphonesIcon, BadgeCheckIcon } from 'lucide-react';
import { PaymentBadges } from './PaymentBadges';
export function TrustBar() {
  const items = [{
    icon: LockIcon,
    title: 'Pagamento Sicuro',
    desc: 'Crittografia SSL 256-bit'
  }, {
    icon: ShieldCheckIcon,
    title: 'Garanzia 100%',
    desc: '45 giorni di prova'
  }, {
    icon: DownloadIcon,
    title: 'Accesso Immediato',
    desc: 'Download istantaneo'
  }, {
    icon: BadgeCheckIcon,
    title: 'Privacy Protetta',
    desc: 'Dati personali al sicuro'
  }, {
    icon: HeadphonesIcon,
    title: 'Supporto Dedicato',
    desc: 'Assistenza via email'
  }];
  return <div className="w-full bg-white border-y border-gray-200 py-10" data-id="element-290">
      <div className="max-w-5xl mx-auto px-4" data-id="element-291">
        <div className="text-center mb-8" data-id="element-292">
          <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center justify-center gap-2" data-id="element-293">
            <LockIcon className="w-5 h-5 text-green-600" data-id="element-294" />
            Transazione Sicura al 100%
          </h3>
          <p className="text-gray-500 text-sm" data-id="element-295">
            I tuoi dati sono protetti dai pi&ugrave; alti standard di sicurezza
            bancaria
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-8" data-id="element-296">
          {items.map((item, idx) => <div key={idx} className="flex flex-col items-center text-center gap-2" data-id="element-297">
              <div className="bg-blue-50 p-3 rounded-full text-blue-600 mb-1" data-id="element-298">
                <item.icon className="w-6 h-6" data-id="element-299" />
              </div>
              <span className="text-sm font-bold text-gray-900" data-id="element-300">
                {item.title}
              </span>
              <span className="text-xs text-gray-500" data-id="element-301">{item.desc}</span>
            </div>)}
        </div>

        <div className="flex justify-center pt-6 border-t border-gray-100" data-id="element-302">
          <PaymentBadges data-id="element-303" />
        </div>
      </div>
    </div>;
}